<template>
  <v-card
    outlined
    class="fill-height"
  >
    <v-card-text>
      <SectionTitle :title="$t('views.production-technician.material')" />
      <v-data-table
        :headers="headers"
        :items="items"
        style="overflow: auto"
        height="100%"
        dense
        fixed-header
        single-select
        disable-pagination
        hide-default-footer
        class="row-pointer mt-2"
      >
        <template #headerCell="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template #item="{ item }">
          <tr
            :class="{ 'grey lighten-2': item.id === selectedFormula }"
            @click="onFormulaSelected(item)"
          >
            <td>{{ item.formula }}</td>
            <td class="text-xs-right">
              <TrendChip
                v-if="item.BConformite"
                :risk="item.BConformite.risk"
              />
            </td>
            <td class="text-xs-right">
              <TrendChip
                v-if="item.BQualFrais"
                :risk="item.BQualFrais.risk"
              />
            </td>
            <td class="text-xs-right">{{ formatDelay(item.delay) }}</td>
            <td class="text-xs-right">{{ formatFc(item.fcAvg) }}</td>
            <td class="text-xs-right">
              <TrendChip :risk="computeRisk(item.IQBeton)" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import SectionTitle from '@/components/core/SectionTitle.vue'
import TrendChip from '@/components/DashViews/Charts/TrendChip.vue'
import { computeRiskFromWeight } from '@/utils/kpi'
import { formatDelay, formatFc } from '@/utils/concrete'

export default {
  name: 'ConcreteFormulaList',
  components: {
    SectionTitle,
    TrendChip,
  },
  props: {
    selectedFormula: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('enums.headers.concreteFormula'),
          value: 'formula',
        },
        { text: this.$t('enums.kpi.BConformite'), value: 'BConformite' },
        { text: this.$t('enums.kpi.BQualFrais'), value: 'BQualFrais' },
        {
          text: this.$t('enums.headers.concreteDelay'),
          value: 'delay',
        },
        { text: this.$t('enums.headers.concreteFc'), value: 'fcAvg' },
        { text: this.$t('enums.headers.risk'), value: 'IQBeton' },
      ]
    },
  },
  methods: {
    onFormulaSelected(value) {
      if (value.id !== this.selectedFormula) {
        this.$emit('onFormulaSelected', value)
      }
    },
    computeRisk: computeRiskFromWeight,
    formatDelay,
    formatFc,
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/material-dashboard/variables.scss';
</style>
